export default function imgUrl(imagePath) {
   return process.env.PUBLIC_URL + imagePath
}